// Raw markdown source for the moderator guide. Imported via Vite's `?raw`
// loader so the content travels with the bundle and stays in sync with the
// docs/ folder — the source of truth is `docs/pride-history/moderator-guide.md`.
// `vite.config.ts` declares the `..` allow-list entry so the loader can reach
// outside the moderation-ui package root.
import md from '../../../../docs/pride-history/moderator-guide.md?raw';

export const moderatorGuideMarkdown: string = md;
